<template>
  <div :id="parentContainerId+'-group'"
      :class="{
        'tag-group': display === 'tag',
        'tag-group-text': display === 'text',
        'tag-group-negative': group.negative
      }">
    <div v-if="display === 'tag'">
      <app-tag v-for="(mention, i) in group.tags" :key="mention+i"
          parentContainerId="qb-filters-group"
          :tag="mention"
          @deleteMentionTag="deleteMentionTag"
          @negateMentionTag="negateMentionGroup"
        />
        <span
          aria-hidden="true"
          class="fas expand fa-ellipsis-h"
          v-tooltip="$t('filter.spread_grouped_filters')"
          @click="() => spreadMentionGroup(group)"
        ></span>
    </div>
    <template v-else-if="display === 'text'">
      <span v-if="group.negative === true" class="joiner not">{{$t('advanced.not')}}</span>
      (
        <template v-for="(mention, i) in group.tags">
          <app-tag
            :key="mention+i"
            parentContainerId="qb-filters-group"
            :tag="mention"
            display="text"
          />
          <span v-if="i < group.tags.length - 1 && display === 'text'" :key="mention+i+'or'" class="joiner or">
            {{$t('advanced.or')}}
          </span>
        </template>
      )
    </template>
  </div>
</template>

<script>
  import editor from '../../helpers/editor';
  import Tag from './tag';

  export default {
    props: {
      parentContainerId: String,
      group: Object,
      display: {
        type: String,
        default: () => 'tag'
      },
    },
    components: {
      'app-tag': Tag
    },
    methods: {
      deleteMentionTag(tag) {
        this.$emit('deleteMentionTag', tag);
      },
      negateMentionGroup (tag) {
        this.$emit('negateMentionGroup');
      },
      spreadMentionGroup (group) {
        this.$emit('spreadMentionGroup', group);
      }
    }
  }
</script>
